<template>
    <section class="section our-goal ptb_100" style="margin-top:100px">
    <br>
    <br>
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-12 col-lg-6">
                    <!-- Goal Content -->
                    <div class="goal-content section-heading text-center text-lg-left pr-md-4 mb-0">
                        <!-- <h2 class="mb-3">"RAFCO"</h2> -->
                        <p>{{$t('aboutus.header_1')}}</p>
                        <p>{{$t('aboutus.line_2')}}</p><br>
                        <p>{{$t('aboutus.mission_1')}}</p>
                        <p>{{$t('aboutus.mission_2')}}</p><br>

                        <p>{{$t('aboutus.our_services')}}</p>
                        <p>{{$t('aboutus.our_services_1')}}</p><br>

                        <p>{{$t('aboutus.vision')}}</p>
                        <p>{{$t('aboutus.vision_1')}}</p>
                        <!-- <a href="#" class="btn btn-bordered mt-4">Read More</a> -->
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Goal Thumb -->
                    <div class="goal-thumb mt-5 mt-lg-0">
                        <img src="https://firebasestorage.googleapis.com/v0/b/spdev-f487e.appspot.com/o/aboutus-spdev.png?alt=media&token=36a60617-7caf-4033-857b-32cc2b48e63d" alt="AboutUs Spdev">
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>